import AbstractMediator from "slotworks/mediators/abstract-mediator";
import Bet from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import Contract from "slotworks/utils/contract";
import Components from "slotworks/components/components";
import RainbowStacksRespinRecord  from "integration/revolver/schema/respin-record";
import BonusBuyContainer from "components/bonus-buy/bonus-buy-container";
import getJackpotTypeFromSymbol from "util/jackpot";

export default class RSBigWinMediator extends AbstractMediator {

    public start(): Contract<boolean> {

        let winnings;
        let gameplay = GameState.getCurrentGame();
        if (gameplay.getCurrentRecord().beenPaid) {
            winnings = gameplay.totalCreditsWon;
        } else {
            winnings = gameplay.getCurrentRecord().creditsWon;
        }
        let stake;
        if(gameplay.isBuyout) {
            if(gameplay.totalBet) {
                stake = gameplay.totalBet;
            } else {
                const record = gameplay.getCurrentRecord();
                if(record instanceof RainbowStacksRespinRecord && !record.inFreespins) {
                    const type = getJackpotTypeFromSymbol(record).toUpperCase() as "MINI" | "MAXI" | "MAJOR" | "GRAND";
                    const multiplier = BonusBuyContainer.MULTIPLIER_RESPIN[type];
                    stake = Bet.getTotalBet() * multiplier;
                } else {
                    stake = Bet.getTotalBet() * BonusBuyContainer.MULTIPLIER_FREESPINS;
                }
            }
        } else {
            stake = Bet.getTotalBet();
        }

        return Components.bigWin.showWin(winnings, stake);
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/mediators/big-win-mediator.ts